export default __webpack_public_path__ + "static/media/car-img-03.6ba6c064.png";